module.exports = __webpack_public_path__ + "img/chemical03.a2412c7f.png";